import { createContext } from 'react';
export var RouteContext = /*#__PURE__*/createContext({});